var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestigatororangetick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0C11.6421 0 15 3.35787 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35787 15 0 11.6421 0 7.5C0 3.35787 3.35787 0 7.5 0ZM3.98938 7.94528L6.12537 9.90687C6.43697 10.1936 6.91925 10.1784 7.21222 9.87613L11.0228 6.22772C11.3327 5.92956 11.3423 5.43659 11.0441 5.12669C10.746 4.81675 10.253 4.80719 9.94309 5.10531L6.64231 8.26562L5.04469 6.79844C4.728 6.50703 4.23503 6.5275 3.94362 6.84419C3.65222 7.16091 3.67269 7.65387 3.98938 7.94528Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestigatororangetick);
export default __webpack_public_path__ + "static/media/investigatororangetick.dc3c3772c0a4c604e176e649144f1335.svg";
export { ForwardRef as ReactComponent };